import {
    AfterViewInit,
    ApplicationRef,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    forwardRef,
    Host,
    HostBinding,
    OnChanges,
    OnDestroy,
    OnInit,
    Optional,
    SimpleChanges,
    SkipSelf,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';


import _ from 'lodash';
import { AzControl } from '../interfaces/AzControl';
import { ControlContainer } from '../interfaces/ControlContainer';
import { FormComponent } from '../form.component';


export const controlNameBinding: any = {
    provide: AzControl,
    useExisting: forwardRef(() => FormFieldComponent)
};


@Component({
    selector: 'form-field',
    template: `
        <ng-content></ng-content>`,
    styles: [`
      form-field.hidden {
            display: none!important;
      }
    `],
    providers: [controlNameBinding],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

/**
 * @description
 * Syncs a `FormControl` in an existing `FormGroup` to a form control
 * element by name.
 *
 * @usageNotes
 *
 * In addition, this pattern mixes template-driven and reactive form strategies, which
 * we generally don't recommend because it doesn't take advantage of the full benefits of
 * either strategy. Setting the value in the template violates the template-agnostic
 * principles behind reactive form, whereas adding a `FormControl`/`FormGroup` layer in
 * the class removes the convenience of defining form in the template.
 *
 * To update your code before v7, you'll want to decide whether to stick with reactive form
 * directives (and get/set values using reactive form patterns) or switch over to
 * template-driven directives.
 *
 *
 * ```html
 * <az-form [formGroup]="formGroup">
 *   <form-control name="first">
 * </form>
 * ```
 *
 * ```ts
 * this.formGroup.get('first').setValue('some value');
 * ```
 *
 * @ngModule ReactiveFormsModule
 * @publicApi
 */
export class FormFieldComponent extends AzControl implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    ///-----------------------------------------------  Variables   -----------------------------------------------///
    
    template: TemplateRef<any>;
    
    // context: ComponentContext;
    
    @ViewChild('default_template', {static: false}) defaultTpl;
    @ViewChild('content_template', {static: false}) private _contentTpl;
    
    @HostBinding('attr.class')
    get attribute(): string {
        return this.name;
    }
    
    @HostBinding('class.form-control') setClass = true;
    
    // @HostBinding('class.hidden')
    // get hiddenStyle(): Boolean {
    //     return _.get(this.control.options, ['hidden']);
    // }
    
    
    // @HostBinding('class.hideLabel')
    // get isHideLabel(): Boolean {
    //     return _.get(this.control.options, ['hideLabel']);
    // }
    //
    // @HostBinding('class.hideFeedback')
    // get isHideFeedback(): Boolean {
    //     return _.get(this.control.options, ['hideFeedback']);
    // }
    
    @HostBinding('class.focused')
    get _isFocused() {
        return this.control.focused;
    }
    
    @HostBinding('class.blurred')
    get _isBlurred() {
        return !this.control.focused;
    }
    
    @HostBinding('class.invalid')
    get _isInvalid() {
        return this.control.invalid && (this.control.dirty || this.control.touched || this.root.submitted);
    }
    
    @HostBinding('class.empty')
    get _isEmpty() {
        return (this.control.value === '' || this.control.value === undefined || this.control.value === null);
    }
    
    
    @HostBinding('class.dirty')
    get _isDirty() {
        return this.control.dirty;
    }
    
    @HostBinding('class.disabled')
    get _isDisabled() {
        return this.control.disabled;
    }
    
    // @HostBinding('class.readonly')
    // get _isReadonly() {
    //     return this.control.options.readonly;
    // }
    //
    ///-----------------------------------------------  Life Cycle Hook   -----------------------------------------------///
    constructor(
            @Optional() @Host() @SkipSelf()  parent: ControlContainer,
            @Optional() @Host() @SkipSelf() public rootParent: FormComponent,
            cd: ChangeDetectorRef,
            private appRef: ApplicationRef,
            private _elRef: ElementRef
    ) {
        super(cd);
        this.parent = parent;
    }
    
    ngOnInit(): void {
        super.ngOnInit();
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        
    }
    
    ngAfterViewInit(): void {
        super.ngAfterViewInit();
    }
    
    /**
     * @description
     * Lifecycle method called before the pre-built's instance is destroyed. For internal use only.
     */
    ngOnDestroy(): void {
    
    }
}
